/**
 * Minimum OS versions supported by Nile apps.
 * Used to show UnsupportedOSDialog when the user's device is below these versions.
 */
export const MIN_IOS_VERSION = 15.5;
export const MIN_ANDROID_VERSION = 7; // API 24 / Android 7.0 Nougat
/** Windows NT version (e.g. 10 = Windows 10/11). Windows 7 = 6.1, 8 = 6.2, 8.1 = 6.3 */
export const MIN_WINDOWS_NT_VERSION = 10;
/**
 * macOS version - we only warn on 10.14 (Mojave) and below.
 * Browsers cap reported macOS at 10.15.7 for privacy (Chrome, Safari, Firefox),
 * so macOS 11–15 all report as 10.15.7. We treat 10.15.x as supported.
 */
export const MIN_MACOS_VERSION = 10.15;

/**
 * Outdated OS versions mentioned in UnsupportedOSDialog.
 */
export const OUTDATED_OS_DIALOG_NOTES = {
  windows: 'Windows 7 and 8 are no longer supported by Microsoft.',
  macos: 'macOS 10.14 (Mojave) and below are no longer supported by Apple.',
} as const;
